module.exports = {
    abrirJanelaVideo: 'Abrir janela de vídeo',
    alertaTrocaRede: 'Não é possível alterar a rede enquanto estiver realizando um atendimento.',
    anexar: 'Anexar',
    anexarArquivo: 'Anexar arquivos',
    anexos: 'Anexos',
    anexoInvalido: 'Anexo inválido.',
    ano: 'Ano de nascimento',
    atendenteMesmaRede: 'Atendente da mesma rede',
    atendentes: 'Atendentes',
    atendentesAdicionados: 'Atendentes adicionados',
    atendimento: 'Atendimento',
    atendimentoEncerrado: 'O seu atendimento foi encerrado.',
    atendimentos: 'Atendimentos',
    avisoSemConexao: 'Ops! Parece que perdemos a conexão com o servidor de Suporte. Verifique sua conexão com a internet e aguarde, o sistema será recarregado automaticamente assim que a conexão for restabelecida. Se preferir, você pode recarregar manualmente clicando <a href="."><b>aqui</b></a>.',
    buscandoCpf: `Aguarde. Buscando dados do seu CPF...`,
    buscarMais: 'Buscar mais',
    cadastrarMensagem: 'Cadastrar mensagem',
    cadastroRede: "Cadastro de rede",
    chamadaVideo: 'Iniciar atendimento por vídeo',
    chat: 'Chat',
    concluido: 'Concluído',
    concordo: 'Concordo',
    confirmarFinalizarAtendimento: 'Você tem certeza que deseja finalizar este atendimento?',
    confirmarLiberarAtendente: nome => `O atendente "${nome}" está solicitando acesso a este atendimento. Você libera o acesso?`,
    confirmarSalvarRespostaRapida: 'Deseja salvar essa resposta rápida?',
    confirmarSalvarRede: 'Você tem certeza que deseja salvar os dados desta rede?',
    dadosPessoais: 'Dados pessoais',
    definicao: 'Definição',
    descricao: 'Descrição',
    dia: 'Dia de nascimento',
    digiteMensagem: 'Digite sua mensagem...',
    discordo: 'Discordo',
    encaminhando: 'Encaminhando...',
    encaminharAtendimento: 'Encaminhar atendimento',
    enviandoArquivo: 'Enviando arquivo...',
    enviandoCadastro: 'Enviando cadastro...',
    enviarMensagem: 'Enviar mensagem',
    erroCarregarDadosRede: 'Ocorreu um erro ao carregar os dados da rede.',
    erroDescricao: 'A descrição deve ter pelo menos 10 caracteres válidos',
    espera: 'Em espera',
    fecharAtendimento: 'Fechar janela de atendimento',
    fecharChamadaVideo: 'Fechar atendimento por vídeo',
    fecharHistorico: 'Fechar histórico',
    finalizarAtendimento: 'Finalizar atendimento',
    historico: 'Histórico',
    historicoAtendimento: 'Histórico dos atendimentos',
    inserirAnexo: 'Inserir anexo',
    jaOnline: 'Você já está conectado no módulo de Teleatendimento através de outra aba, navegador ou dispotivo.',
    limiteDeArquivos: 'Limite de arquivos excedido',
    maximoCaracterExcedido: 'Máximo de caracteres excedido',
    mensagemSolicitacaoAcessoAtendimento: 'Uma solicitação de acesso a este atendimento foi enviada para o atendente responsável. Por favor, aguarde.',
    menuAtendimento: 'Atendimento',
    mes: 'Mês de nascimento',
    nenhumaMensagemEnviadaAtendimento: 'Nenhuma mensagem de texto foi enviada neste atendimento.',
    nenhumAnexoEnviadaAtendimento: 'Nenhum anexo foi enviado neste atendimento.',
    nenhumaRespostaCadastrada: 'Nenhuma resposta rápida configurada para esta rede.',
    notificacaoFecharAtendimento: 'O atendimento atual ainda está em andamento. Ao fechar a janela o atendimento será encerrado. Você confirma esta ação?',
    notificacaoNovaMensagemAnexo: 'Envio um anexo.',
    notificacaoNovoAtendimento: 'Você já está realizando um atendimento neste momento. Se você iniciar um novo atendimento ou visualizar as mensagens de outro atendimento, o atual será finalizado. Você confirma esta ação?',
    notificacaoSolicitacaoAtendimento: 'Um usuário solicitou atendimento.',
    notificacaoTabNovaMensagem: '✉️ Nova mensagem enviada',
    notificacaoTabSolicitacaoAtendimento: '🟠 Atendimento solicitado',
    observacao: 'Digite uma observação',
    outraRede: 'Para outra rede',
    outrasRespostas: 'Outras respostas',
    pesquisaRedes: 'Pesquisa de redes',
    pesquisaRespostas: 'Pesquisa de respostas',
    preCadastro: 'Para ir ao teleatendimento você deve fazer este pequeno pré-cadastro.',
    preenchaCpf: 'Preencha o CPF para começar o teleatendimento.',
    resposta: 'Resposta',
    respostas: 'Respostas',
    respostaRapida: 'Resposta rápida',
    RespostasRapidas: 'Respostas Rápidas',
    respostasRapidasAtivas:'Respostas rápidas ativas',
    respostasSelecionadas:'Respostas selecionadas',
    salvando: 'Salvando termo de consentimento...',
    selecionarEmoji: 'Selecionar emoji',
    selecioneArquivo: 'Selecione um arquivo',
    selecioneRede: 'Rede para atendimento',
    selecioneUsuario: 'Selecione um usuário para iniciar ou continuar um atendimento.',
    semAtendenteEncaminhar: 'Não há outros atendentes disponíveis para encaminhar o atendimento.',
    semAtendenteEncaminharRede: 'Não há atendentes disponíveis nesta rede para continuar o atendimento deste usuário.',
    semHistorico: 'Nenhum registro de atendimento encontrado.',
    solicitarAtendimento: 'Solicitar atendimento',
    suporte: 'Suporte',
    somenteImagens: 'Somente imagens podem ser coladas diretamente no chat. Para arquivos de outros formatos, use a opção de anexar manualmente.',
    somenteUmaImagem: 'Somente uma imagem por vez pode ser colada diretamente no chat.',
    teleatendimento: 'Teleatendimento',
    teleatendimentoPaciente: 'Serviço de teleatendimento a pacientes',
    termo: 'Termo de consentimento',
    textoAguarde: nome => `Olá, ${nome}!`,
    textoAguardeAtendimento: 'Aguarde seu atendimento.',
    textoAguardeSemAtendentes: 'No momento não há atendentes.',
    textoAtendenteConectado: 'Atendente conectado, por favor retire sua dúvida.',
    textoAtendimentoFinalizado: 'O atendente encerrou este atendimento.',
    textoCliqueAbrirHistorico: 'Verifique seu histórico <a href="javascript:void(0)"><b>aqui</b></a>.',
    textoCliqueSolicitarAtendimento: 'Solicite seu atendimento <a href="javascript:void(0)"><b>aqui</b></a>.',
    tipoEncaminhamento: 'Para quem você deseja encaminhar este atendimento?',
    usuariosParaAtendimento: 'Usuários para atendimento',
    validar: 'Validar',
    online:'online',
    validarDados: 'Para validarmos seu cadastro, por favor digite os dados solicitados abaixo.',
}